import dayjs from 'dayjs';

const calculateRemainingDays = (endDate: string): number => {
  const now = dayjs();
  const end = dayjs(endDate);
  const difference = end.diff(now, 'day');
  return difference > 0 ? difference : 0;
};

export default calculateRemainingDays;
